export default {

    'proofread': {
        'text_quality.grammar': {
            name: 'proofread.text_quality.grammar',
            label: 'Grammar',
            icon: 'fa fa-list-check',
            query: {section: 'proofread'},
            color: 'bg-icon-purple'
        },
        'text_quality.readability': {
            name: 'proofread.text_quality.readability',
            label: 'Readability',
            icon: 'fa fa-solid fa-glasses',
            query: {section: 'proofread'},
            color: 'bg-icon-orange'
        },
        'text_quality.tone': {
            name: 'proofread.text_quality.tone',
            label: 'Tone',
            icon: 'fa fa-solid fa-microphone-lines',
            query: {section: 'proofread'},
            color: 'bg-icon-orange'
        },
        'text_quality.spelling': {
            name: 'proofread.text_quality.spelling',
            label: 'Spelling',
            icon: 'fa fa-spell-check',
            query: {section: 'proofread'},
            color: 'bg-icon-blue'
        },
        'text_quality.capitalization': {
            name: 'proofread.text_quality.capitalization',
            label: 'Capitalization',
            icon: 'fa fa-text-height',
            query: {section: 'proofread'},
            color: 'bg-icon-gray'
        },
        'content_errors.visible_error_message': {
            name: 'proofread.content_errors.visible_error_message',
            label: 'Visible Error Message',
            icon: 'fa-solid fa-bug',
            query: {section: 'proofread'},
            color: 'bg-icon-blue'
        },
        'content_errors.placeholder_text': {
            name: 'proofread.content_errors.placeholder_text',
            label: 'Placeholder Text',
            icon: 'fa-solid fa-file-code',
            query: {section: 'proofread'},
            color: 'bg-icon-blue'
        },
        'content_errors.unreplaced_variable': {
            name: 'proofread.content_errors.unreplaced_variable',
            label: 'Unreplaced Variables',
            icon: 'fa-solid fa-code-pull-request',
            query: {section: 'proofread'},
            color: 'bg-icon-blue'
        },
        'content_errors.missing_referenced_element': {
            name: 'proofread.content_errors.missing_referenced_element',
            label: 'Missing Elements',
            icon: 'fa-solid fa-file-circle-exclamation',
            query: {section: 'proofread'},
            color: 'bg-icon-purple'
        },
        'content_errors.image_text_conflict': {
            name: 'proofread.content_errors.image_text_conflict',
            query: {section: 'proofread'},
            label: 'Image<->Text Mismatch'
        },
        'content_errors.spam_content': {
            name: 'proofread.content_errors.spam_content',
            label: 'Spam Content',
            icon: 'fa-solid fa-envelope-open-text',
            query: {section: 'proofread'},
            color: 'bg-icon-blue'
        },
        'logic.contradictory_facts': {
            name: 'proofread.logic.contradictory_facts',
            label: 'Contradictory Facts',
            icon: 'fa-solid fa-scale-unbalanced',
            query: {section: 'proofread'},
            color: 'bg-icon-purple'
        },
        'logic.numerical_inconsistency': {
            name: 'proofread.logic.numerical_inconsistency',
            label: 'Numerical Inconsistency',
            icon: 'fa-solid fa-calculator',
            query: {section: 'proofread'},
            color: 'bg-icon-purple'
        },
        'logic.heading_content_mismatch': {
            name: 'proofread.logic.heading_content_mismatch',
            label: 'Heading<->Text Mismatch',
            icon: 'fa-solid fa-heading',
            query: {section: 'proofread'},
            color: 'bg-icon-purple'
        },
        'visual.broken_image': {
            name: 'proofread.visual.broken_image',
            label: 'Broken Image',
            icon: 'fa fa-image',
            query: {section: 'proofread'},
            color: 'bg-icon-blue'
        },
        'visual.layout_flow': {
            name: 'proofread.visual.layout_flow',
            query: {section: 'proofread'},
            label: 'Layout Flow'
        },
        'visual.low_contrast': {
            name: 'proofread.visual.low_contrast',
            query: {section: 'proofread'},
            label: 'Low Contrast'
        },
    },
    'technical': {
        'missing_alt': {
            name: 'technical.missing_alt',
            label: 'Missing Alt Tag',
            icon: 'fa fa-file-image',
            query: {section: 'audit'},
            color: 'bg-icon-blue'
        },
        'broken_image': {
            name: 'technical.broken_image',
            label: 'Broken Image',
            icon: 'fa fa-image',
            query: {section: 'audit'},
            color: 'bg-icon-blue'
        },
        'broken_link': {
            name: 'technical.broken_link',
            label: 'Broken Link',
            icon: 'fa-solid fa-link-slash',
            query: {section: 'audit'},
            color: 'bg-icon-purple'
        },
        'internal_redirect': {
            name: 'technical.internal_redirect',
            label: 'Internal Redirect',
            icon: 'fa fa-link',
            query: {section: 'audit'},
            color: 'bg-icon-purple'
        },
        'missing_title': {
            name: 'technical.missing_title',
            label: 'Missing Title',
            icon: 'fa fa-code',
            query: {section: 'audit'},
            color: 'bg-icon-green'
        },
        'missing_description': {
            name: 'technical.missing_description',
            label: 'Missing Description',
            icon: 'fa-solid fa-heading',
            query: {section: 'audit'},
            color: 'bg-icon-green'
        },
        'missing_favicon': {
            name: 'technical.missing_favicon',
            label: 'Missing Favicon',
            icon: 'fa-solid fa-sitemap',
            query: {section: 'audit'},
            color: 'bg-icon-green'
        },
        'broken_resource': {
            name: 'technical.broken_resource',
            label: 'Broken Resource',
            icon: 'fa-solid fa-file-circle-xmark',
            query: {section: 'audit'},
            color: 'bg-icon-orange'
        },
        'console_error': {
            name: 'technical.console_error',
            label: 'Console Error',
            icon: 'fa-solid fa-terminal',
            query: {section: 'audit'},
            color: 'bg-icon-orange'
        },
    },
    'layout': {
        'aspect_ratio': {
            name: 'layout.aspect_ratio',
            label: 'Aspect Ratio',
            heading: 'pages with stretched images detected',
            icon: 'fa-solid fa-image',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'Image displayed with incorrect aspect ratio.',
            description: 'Images are being displayed with an incorrect aspect ratio, causing them to appear stretched or squished.',
            fix: 'Set a consistent aspect-ratio in CSS, or ensure both width and height attributes are proportional to the original image dimensions.'
        },
        'text_overlap': {
            name: 'layout.text_overlap',
            label: 'Overlapping Text',
            heading: 'pages with overlapping text detected',
            icon: 'fa-solid fa-align-justify',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'Overlapping text can cause severe readability issues.',
            description: 'Two or more text elements are occupying the same space, making the content difficult or impossible to read.',
            fix: 'Adjust line-height, margins, or padding. Check for absolute positioning or fixed heights that might be constraining the text container.'
        },
        'button_overlap': {
            name: 'layout.button_overlap',
            label: 'Overlapping Buttons',
            heading: 'pages with overlapping buttons detected',
            icon: 'fa-solid fa-layer-group',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'Overlapping buttons can cause severe readability issues.',
            description: 'Interactive buttons are overlapping, which can prevent users from clicking the intended element.',
            fix: 'Increase spacing between buttons using margins or gap properties. Ensure the container has enough space to accommodate all buttons on smaller screens.'
        },
        'narrow': {
            name: 'layout.narrow',
            label: 'Missing Breakpoint',
            heading: 'pages with text flow issues detected',
            icon: 'fa-solid fa-box-open',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'Very tall and narrow text usually is caused by a missing breakpoint.',
            description: 'Text containers are too narrow, causing excessive line breaks and making the content hard to follow.',
            fix: 'Add or adjust responsive breakpoints (media queries) to allow containers to expand on larger screens or stack properly on smaller ones.'
        },
        'lsep': {
            name: 'layout.lsep',
            label: 'Invisible Characters',
            heading: 'pages with invisible (LSEP) characters detected',
            icon: 'fa-solid fa-paragraph',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'On certain browsers this will display as a box (☐) or cause spacing issues between words.',
            description: 'Line Separator (LSEP) characters are present in the text. These may appear as boxes (☐) or cause unexpected spacing in some browsers.',
            fix: 'Remove these hidden characters from your content source or CMS. They are often accidentally introduced during copy-paste from other applications.'
        },
        'etx': {
            name: 'layout.etx',
            label: 'Invisible Characters',
            heading: 'pages with invisible (ETX) characters detected',
            icon: 'fa-solid fa-paragraph',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'On certain browsers this will display as a box (☐) or cause spacing issues between words.',
            description: 'End of Text (ETX) characters are present. These control characters can cause rendering artifacts like boxes (☐) in several browsers.',
            fix: 'Clean your text data to remove non-printable ASCII characters. Check your database or content editor for hidden control codes.'
        },
        'unsupported_unicode': {
            name: 'layout.unsupported_unicode',
            label: 'Unsupported Unicode',
            heading: 'pages with unsupported unicode detected',
            icon: 'fa-solid fa-font',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'These might display as a box (☐) or similar depending on the browser.',
            description: 'The page contains Unicode characters that the user\'s browser or font may not support, typically appearing as a replacement character or box (☐).',
            fix: 'Use standard web-safe fonts or ensure your custom web fonts include the necessary glyphs. Alternatively, replace the special characters with standard equivalents.'
        },
        'entity': {
            name: 'layout.entity',
            label: 'Double Escaped Entity',
            heading: 'pages with double escaped entities detected',
            icon: 'fa-solid fa-font',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'HTML entities that have been encoded twice (e.g., &amp;amp;).',
            description: 'The page contains HTML entities that have been encoded twice, causing them to display as the entity code itself (like &amp; or &quot;) instead of the intended character.',
            fix: 'Check your content rendering pipeline or CMS. Ensure that text is not being escaped twice before being sent to the browser.'
        },
        'horizontal_scrolling': {
            name: 'layout.horizontal_scrolling',
            label: 'Horizontal Scrolling',
            heading: 'pages with horizontal scrolling detected',
            icon: 'fa-solid fa-arrows-left-right',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'Unless intended pages should not scroll in two dimensions.',
            description: 'The page content is wider than the viewport, forcing users to scroll horizontally, which is a poor experience on mobile devices.',
            fix: 'Identify elements with fixed widths that exceed the screen size. Use max-width: 100% on images and containers, and ensure overflow is handled correctly.'
        },
        'overflowing_container': {
            name: 'layout.overflowing_container',
            label: 'Overflowing Container',
            heading: 'pages overflowing its container detected',
            icon: 'fa-solid fa-box-open',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'The element is overflowing its container.',
            description: 'Elements are breaking out of their parent containers, often causing layout misalignment or overlapping other content.',
            fix: 'Check for fixed heights on parent elements or lack of overflow handling. Use flexbox or grid layouts to ensure children are contained properly.'
        },
        'outside_window': {
            name: 'layout.outside_window',
            label: 'Text Outside Window',
            heading: 'pages with text flowing outside the window detected',
            icon: 'fa-solid fa-box-open',
            color: 'bg-icon-blue',
            query: {section: 'audit'},
            info: 'Text flows outside of window',
            description: 'Text is rendered outside the visible area of the browser window, making it inaccessible to the user.',
            fix: 'Ensure all containers use responsive units (like % or vw) and avoid large negative margins or absolute positioning that pushes content off-screen.'
        },
    },
    'ai_readiness': {
        'crawlability': {
            name: 'ai_readiness.crawlability',
            label: 'Crawlability issues',
            icon: 'fa-solid fa-bug',
            query: {section: 'ai_readiness'},
            color: 'bg-icon-red'
        },
        'visual_state_indicators': {
            name: 'ai_readiness.visual_state_indicators',
            label: 'Visual State Indicators',
            icon: 'fa-solid fa-eye',
            query: {section: 'ai_readiness'},
            color: 'bg-icon-blue'
        },
        'semantic_hierarchy': {
            name: 'ai_readiness.semantic_hierarchy',
            label: 'Semantic Hierarchy',
            icon: 'fa-solid fa-sitemap',
            query: {section: 'ai_readiness'},
            color: 'bg-icon-green'
        },
        'ghost_content': {
            name: 'ai_readiness.ghost_content',
            label: 'Ghost Content',
            icon: 'fa-solid fa-ghost',
            query: {section: 'ai_readiness'},
            color: 'bg-icon-purple'
        },
        'text_in_image': {
            name: 'ai_readiness.text_in_image',
            label: 'Text in Image',
            icon: 'fa-solid fa-file-image',
            query: {section: 'ai_readiness'},
            color: 'bg-icon-purple'
        },
        'dynamic_content': {
            name: 'ai_readiness.dynamic_content',
            label: 'Dynamic Content',
            icon: 'fa-solid fa-sync',
            query: {section: 'ai_readiness'},
            color: 'bg-icon-orange'
        },
    },
}
